import React from "react";
import Menu from "@material-ui/core/Menu";

import Fade from "@material-ui/core/Fade";
import IconButton from "@material-ui/core/IconButton";
import { FiMoreVertical } from "react-icons/fi";

import { Container } from "./styles";

export default function MoreVertMenu({ children }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Container>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <FiMoreVertical />
      </IconButton>
      <Menu
        id="fade-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
        onClick={handleClose}
      >
        {children}
      </Menu>
    </Container>
  );
}
